<template>
	<div v-show="$store.getters.isloggedin" class="sticky-top">
		<nav class="navbar navbar-expand-lg navbar-dark bg-secondary">
			<router-link :to="'/'" class="navbar-brand">
				Főoldal
			</router-link>
			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarNavAltMarkup">
				<div class="navbar-nav">
					<ul class="navbar-nav">
						<li class="nav-item dropdown">
					        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					          Rendelések
					        </a>
					        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
					        	<router-link :to="'/orders/new_order/customer'" class="dropdown-item">
									Új rendelés rögzítése
								</router-link>
					          	<router-link :to="'/orders/search'" class="dropdown-item">
									Keresés
								</router-link>
								<router-link
									:to="'/orders/billings'"
									class="dropdown-item"
								>
									Számlázott rendelések
								</router-link>
								<router-link
									:to="'/orders/balanced'"
									class="dropdown-item"
								>
									Kiegyenlítések keresése
								</router-link>
								<router-link
									:to="'/invoices/einvoicelist'"
									class="dropdown-item"
								>
									E-számla lista
								</router-link>
					        </div>
				    	</li>
					</ul>
					<ul class="navbar-nav">
						<li class="nav-item dropdown">
					        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					          Webes rendelések
					        </a>
					        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
					          	<router-link :to="'/weborder/list'" class="dropdown-item">
									Keresés
								</router-link>
					        </div>
				    	</li>
					</ul>
					<ul class="navbar-nav">
						<li class="nav-item dropdown">
					        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					          Ügyfelek
					        </a>
				        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
				        	<router-link :to="'/customers/new_customer'" class="dropdown-item">
								Új ügyfél rögzítése
							</router-link>
				          	<router-link :to="'/customers/search'" class="dropdown-item">
								Ügyfél keresés
							</router-link>
				         	<router-link :to="'/customers/export'" class="dropdown-item">
								Export
							</router-link>
				        </div>
				    	</li>
					</ul>
					<ul class="navbar-nav">
						<li class="nav-item dropdown">
					        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					          Érdeklődők
					        </a>
				        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
							<router-link :to="'/inquiring/create'" class="dropdown-item">
                    			Új érdeklődő rögzítése
                			</router-link>
							<router-link :to="'/inquiring/list'" class="dropdown-item">
								Érdeklődő keresés
							</router-link>
				        </div>
				    	</li>
					</ul>
					<ul class="navbar-nav">
						<li class="nav-item dropdown">
					        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					          Feladatok
					        </a>
				        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
				        	<router-link :to="'/tasks/add_task'" class="dropdown-item" target="_blank">
								Új feladat rögzítése
							</router-link>
				          	<router-link :to="'/tasks/search'" class="dropdown-item">
								Keresés
							</router-link>
				        </div>
				    	</li>
					</ul>

					<ul class="navbar-nav">
						<li class="nav-item dropdown">
					        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					          Statisztika
					        </a>
					        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
					        	<router-link :to="'/stats/gordulo'" class="dropdown-item">
									Gördülő átlag
								</router-link>
								<router-link :to="'/stats/kimikor'" class="dropdown-item">
									Ki mikor rendelt utoljára
								</router-link>
								<router-link :to="'/inventory/list'" class="dropdown-item">
									Raktár készlet
								</router-link>
					        </div>
				    	</li>
					</ul>

					<ul class="navbar-nav">
						<li class="nav-item dropdown">
					        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					          Admin
					        </a>
					        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
					        	<router-link :to="'/managers'" class="dropdown-item">
									Kezelők
								</router-link>
								<!--<div class="dropdown-divider"></div>-->
								<router-link :to="'/profile'" class="dropdown-item">
									Profilom
								</router-link>
								<router-link :to="'/categories'" class="dropdown-item">
									Kategóriák
								</router-link>
								<router-link :to="'/types'" class="dropdown-item">
									Típusok
								</router-link>
								<router-link :to="'/products'" class="dropdown-item">
									Termékek
								</router-link>
								<router-link :to="'/lists'" class="dropdown-item">
									Listák
								</router-link>
								<router-link :to="'/admin/emails'" class="dropdown-item">
									Email kiküldések
								</router-link>
					        </div>
				    	</li>
					</ul>

				</div>
				<button class="btn btn-danger m-1" @click.prevent="logout">
					Kilépés
				</button>
				<button class="btn btn-success mr-sm-2" disabled>
					{{version}}
				</button>
			</div>
		</nav>
	</div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
	name: 'navbar',

  	watch: {
	    '$route' () {
	    	$('#navbarNavAltMarkup').collapse('hide')
	    }
	},

	methods: {
		...mapActions(['logout'])
	}
}
</script>


// WEBPACK FOOTER //
// src/components/navbar.vue